import { TReportAdminScope } from "../reportCatalog.types";
import { TQuickExportTemplateId } from "./quickExportTemplates";

const NO_EXPORT_CODES = new Set(["rounds-by-customer-type", "item-sales-history"]);

const FACILITY_TEMPLATE_OVERRIDES: Record<string, TQuickExportTemplateId> = {
  "daily-sales": "dateRangeWithRegisterFilters",
  bookings: "dateRangeWithRegisterFilters",
  "compare-sales-by-date": "compareSalesByDate",
  "cost-of-sales-by-department": "dateRangeWithVendorDeptFilters",
  "detailed-sales-by-department": "dateRangeWithVendorDeptFilters",
  "detailed-sales-and-inventory-by-department": "dateRangeWithVendorDeptFilters",
  "sales-by-accounting-reference": "dateRangeWithRegisterIdsOnly",
  "sales-by-department": "dateRangeWithRegisterIdsOnly",
  "sales-by-accounting-reference-standalone": "dateRangeWithRegisterIdsOnly",
  "aged-accounts-receivable": "singleDateAgedAr",
  "golfnorth-daily-sales": "singleDate",
  "inventory-listing-by-department": "singleDate",
  "server-summaries": "serverSummaries",
  "prize-accounts": "prizeAccounts",
  "credit-books": "creditBooks",
  accounts: "accountsWithCustomerTypes",
  "account-activity": "accountsWithCustomerTypes",
  "booking-deposits": "bookingDeposits",
  "accounts-receivable": "accountsReceivableZeroBalance",
  "user-payment-methods": "userPaymentMethods",
  "staff-account-shifts": "staffAccountShifts",
  "rounds-by-booking-category": "roundsByBookingCategory",
  transactions: "dateRangeWithRegisterId",
  orders: "dateRangeWithRegisterId",
  "cash-reconciliation": "cashReconciliation",
  "cash-reconciliation-worksheet": "cashReconciliationWorksheet",
  "form-responses": "formResponses",
  "processing-fee-monthly-summary": "singleDate",
};

const CLIENT_TEMPLATE_OVERRIDES: Record<string, TQuickExportTemplateId> = {
  "account-adjustments": "dateRange",
  "scheduled-payments": "dateRange",
  "detailed-sales-by-department": "clientDetailedSalesFilters",
  "order-exceptions": "clientOrderExceptions",
  "aged-accounts-receivable": "clientAgedAr",
  "prize-accounts": "clientPrizeAccounts",
  "bookings-by-source": "clientDateRange",
  "tee-sheet-utilization": "clientTeeSheetUtilization",
  "detailed-sales-and-inventory-by-department": "clientDetailedSalesFilters",
  "hospitality-events-not-invoiced": "clientDateRange",
  "tournaments-not-invoiced": "clientDateRange",
  "golfnorth-daily-sales": "clientSingleDate",
  "inventory-listing-by-department": "clientSingleDate",
  "form-responses": "clientFormResponses",
};

export function hasReportExport(code: string): boolean {
  return !NO_EXPORT_CODES.has(code);
}

export function getQuickExportTemplateId(scope: TReportAdminScope, code: string): TQuickExportTemplateId {
  const overrides = scope === "facility" ? FACILITY_TEMPLATE_OVERRIDES : CLIENT_TEMPLATE_OVERRIDES;
  return overrides[code] ?? (scope === "client" ? "clientDateRange" : "dateRange");
}
